<template>
<svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 70.402 70.402">
  <g id="Group_324" data-name="Group 324" transform="translate(-35.341 -280.286)">
    <circle id="Ellipse_65" data-name="Ellipse 65" cx="35.201" cy="35.201" r="35.201" transform="translate(35.341 280.286)" fill="#fff"/>
    <path id="Path_143" data-name="Path 143" d="M1189.745,1146.2h32.376v35.373a3,3,0,0,1-3,3h-31.176l-.216-.006a4.256,4.256,0,0,1-3.981-4.191V1152.8h5.995Zm0,8.993h-3.6v25.752a.71.71,0,0,0,.206.509c1.549,1.495,3.391.422,3.391-1.08Zm13.19,22.183h-7.194a1.2,1.2,0,1,0,0,2.4h7.194a1.2,1.2,0,1,0,0-2.4Zm13.191-5.4h-8.394v7.794h9.593v-6.595a1.2,1.2,0,0,0-1.2-1.2Zm-13.191.6h-7.194a1.2,1.2,0,0,0,0,2.4h7.194a1.2,1.2,0,1,0,0-2.4Zm13.191-6h-20.385a1.2,1.2,0,1,0,0,2.4h20.385a1.2,1.2,0,1,0,0-2.4Zm-21.584-16.188v13.19h11.991V1150.4h-11.991Zm21.584,10.193h-4.8a1.2,1.2,0,0,0,0,2.4h4.8a1.2,1.2,0,0,0,0-2.4Zm0-4.8h-4.8a1.2,1.2,0,0,0,0,2.4h4.8a1.2,1.2,0,0,0,0-2.4Zm0-4.8h-4.8a1.2,1.2,0,1,0,0,2.4h4.8a1.2,1.2,0,0,0,0-2.4Zm0,0" transform="translate(-1133.858 -850.394)" fill="#1a1818"/>
  </g>
</svg>
</template>

<script>
export default {
  'name': 'SA_03_03',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/attributes/SA_03_03.vue